import React, { useState, useLayoutEffect } from "react";
import { createPortal } from "react-dom";
import "./unlimited_Bonus.css";
import PopupdetailsPackN from "../pack_N/packN";

/* Fond animé du popup VIP (vidéo en boucle, sans son).
   Mets le fichier VIP_Background.mp4 dans public/images/packs/unlimitedBonus/ */
const VIP_BG_VIDEO = "/images/packs/unlimitedBonus/VIP_Background.mp4";

/* Image de secours / affichée pendant le chargement de la vidéo */
const VIP_STATIC_IMAGE = "/images/packs/unlimitedBonus/VIP_BackTR.png";

const packsData = {
  local: [
    { name: "Pack G", image: "Pack_G.png", type: "local" },
    { name: "Pack ultra 3", image: "Pack_Ultra3.png", type: "local" },
    { name: "Pack ultra 4", image: "Pack_Ultra4.png", type: "local" },
    { name: "Pack ultra 5", image: "Pack_Ultra5.png", type: "local" },
    { name: "Pack M11", image: "Pack_M11.png", type: "local" },
    { name: "Pack M13 Pro", image: "Pack_M13_Pro.png", type: "local" },
    { name: "Pack M13 Pro Max", image: "Pack_M13_Pro_Max.png", type: "local" },
    { name: "Pack M14", image: "Pack_M14.png", type: "local" },
    { name: "Pack M14 Plus", image: "Pack_M14_Plus.png", type: "local" },
    { name: "Pack M15", image: "Pack_M15.png", type: "local" },
    { name: "Pack M16", image: "Pack_M16.png", type: "local" },
    { name: "Pack M16 Plus", image: "Pack_M16_Plus.png", type: "local" },
    { name: "Pack M16 Pro Max", image: "Pack_M16_Pro_Max.png", type: "local" },
    { name: "Pack M17", image: "Pack_M17.png", type: "local" },
    { name: "Pack M17 Pro", image: "Pack_M17_Pro.png", type: "local" },
    { name: "Pack M17 Pro Max", image: "Pack_M17_Pro_Max.png", type: "local" },
    { name: "Pack M18 Pro", image: "Pack_M18_Pro.png", type: "local" },
    { name: "Pack M18 Pro Max", image: "Pack_M18_Pro_Max.png", type: "local" },
    { name: "Pack Ultra 1", image: "Pack_Ultra1.png", type: "local" },
    { name: "Pack Ultra 2", image: "Pack_ Ultra2.png", type: "local" },
  ],
  international: [
    { name: "Pack R1", image: "pack_R1.jpg", type: "international" },
    { name: "Pack R2", image: "pack_R2.jpg", type: "international" },
    { name: "Pack R3", image: "pack_R3.jpg", type: "international" },
    { name: "Pack R4", image: "pack_R4.jpg", type: "international" },
    { name: "Pack Rs Air", image: "pack_RS_Air.jpg", type: "international" },
    { name: "Pack Rs Air Pro", image: "pack_RS_Air_Pro.jpg", type: "international" },
    { name: "Pack Rs Air Max", image: "pack_RS_Air_Max.jpg", type: "international" },
    { name: "Pack Rs Air Ultra", image: "pack_Rs_Air_ULTRA.jpg", type: "international" },
    { name: "Pack B1", image: "pack_B1.jpg", type: "international" },
    { name: "Pack B2", image: "pack_B2.jpg", type: "international" },
    { name: "Pack B3", image: "pack_B3.jpg", type: "international" },
    { name: "Pack B4", image: "pack_B4.jpg", type: "international" },
    { name: "Pack TD Pro", image: "pack_TD_Pro.jpg", type: "international" },
    { name: "Pack TD ULTRA", image: "pack_TD_ULTRA.jpg", type: "international" },
    { name: "Pack MWG Ai ULTRA", image: "pack_MWG_Ai_ULTRA.jpg", type: "international" },
    { name: "Pack Halcom", image: "pack_Halcon.jpg", type: "international" },
  ],
  vip: [
    { name: "Pack V1", image: "Pack_V1.png", type: "local" },
    { name: "Pack V2", image: "Pack_V2.png", type: "local" },
    { name: "Pack V3", image: "Pack_V3.png", type: "local" },
    { name: "Pack V4", image: "Pack_V4.png", type: "local" },
    { name: "Pack V Ultra", image: "Pack_V_Ultra.png", type: "local" },
  ],
};

const PopupUnlimitedBonus = ({
  onClose,
  packType = null,
  variant = "standard",
}) => {
  const [selectedPack, setSelectedPack] = useState(null);
  const [rect, setRect] = useState(null);
  const [videoOk, setVideoOk] = useState(true);   // false si la vidéo ne se lit pas
  const [staticOk, setStaticOk] = useState(true);  // false si l'image de secours manque
  const [activeIdx, setActiveIdx] = useState(0); // icône mise en valeur (survol / focus)

  const isVip = variant === "vip";

  const reduceMotion =
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const logos = isVip
    ? packsData.vip
    : packType
      ? packsData[packType] || []
      : [...packsData.local, ...packsData.international];

  useLayoutEffect(() => {
    const measure = () => {
      const el = document.querySelector(".overlayClient");
      if (el) {
        const r = el.getBoundingClientRect();
        setRect({ top: r.top, left: r.left, width: r.width, height: r.height });
      }
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);

  /* Le fond flou couvre TOUTE la page (comme le popup du wallet) :
     plus de rectangle limité au conteneur du dashboard.
     Le popup, lui, reste centré sur le conteneur. */
  const popupStyle = rect
    ? {
        top: rect.top + rect.height / 2,
        left: rect.left + rect.width / 2,
      }
    : undefined;

  /* Un clic sur un pack ouvre directement ses détails */
  const openDetails = (logo) =>
    setSelectedPack({ name: logo.name, type: logo.type });

  return createPortal(
    <>
      {/* borderRadius 0 : pleine page, donc pas de coins arrondis */}
      <div
        className="bonus-backdrop"
        style={{ borderRadius: 0 }}
        onClick={onClose}
      />

      <div
        className={`bonus-popup ${isVip ? "bonus-popup--vip" : ""}`}
        style={popupStyle}
      >
        {!selectedPack ? (
          isVip ? (
            /* ===== VIP : design premium (rail d'icônes, en-tête, image) ===== */
            <div className="vip-window">
              {/* Fond animé : couvre TOUT le popup */}
              <div className="vip-bg" aria-hidden="true">
                {videoOk ? (
                  <video
                    className="vip-bg-media"
                    src={VIP_BG_VIDEO}
                    poster={VIP_STATIC_IMAGE}
                    autoPlay={!reduceMotion}
                    loop
                    muted
                    playsInline
                    preload="auto"
                    disablePictureInPicture
                    tabIndex={-1}
                    onError={() => setVideoOk(false)}
                  />
                ) : (
                  staticOk && (
                    <img
                      className="vip-bg-media"
                      src={VIP_STATIC_IMAGE}
                      alt=""
                      onError={() => setStaticOk(false)}
                    />
                  )
                )}
              </div>

              <span className="vip-glint vip-glint-frame" aria-hidden="true" />

              {/* Gauche : les 5 packs (clic = détails) */}
              <nav
                className="vip-icon-menu"
                aria-label="VIP packs"
                onMouseLeave={() => setActiveIdx(0)}
              >
                {logos.map((logo, i) => (
                  <button
                    key={logo.name}
                    type="button"
                    className={`vip-icon-btn vip-icon-${i + 1} ${
                      activeIdx === i ? "is-active" : ""
                    }`}
                    onClick={() => openDetails(logo)}
                    onMouseEnter={() => setActiveIdx(i)}
                    onFocus={() => setActiveIdx(i)}
                    title={logo.name}
                    aria-label={`${logo.name}: voir les détails`}
                  >
                    <img
                      src={`/images/packs/unlimitedBonus/${logo.image}`}
                      alt=""
                    />
                  </button>
                ))}
              </nav>

              <div className="vip-right">
                {/* En-tête : logo MWGTD + croix pour fermer */}
                <header className="vip-header">
                  <span className="vip-glint vip-glint-top" aria-hidden="true" />
                  <span className="vip-glint vip-glint-bottom" aria-hidden="true" />

                  <div className="vip-brand">
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M2 20 7 5l5 10 5-10 5 15" />
                      <path d="M8 20l4-8 4 8" />
                    </svg>
                    <span>MWGTD</span>
                  </div>

                  <button
                    type="button"
                    className="vip-close"
                    onClick={onClose}
                    aria-label="Fermer"
                  >
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M5 5l14 14M19 5 5 19" />
                    </svg>
                  </button>
                </header>

                {/* Droite : fenêtre transparente (on voit la vidéo de fond) */}
                <main className="vip-main-display">
                  <div className="vip-corner" aria-hidden="true">///</div>
                </main>
              </div>
            </div>
          ) : (
            /* Popup standard : grille d'origine, inchangée */
            <div className="bonus-logo-grid">
              {logos.map((logo) => (
                <div
                  key={logo.name}
                  className="bonus-logo-wrapper"
                  onClick={() => openDetails(logo)}
                >
                  <img
                    src={`/images/packs/unlimitedBonus/${logo.image}`}
                    alt={logo.name}
                    className="bonus-logo"
                  />
                </div>
              ))}
            </div>
          )
        ) : (
          <div className="bonus-details-content">
            <PopupdetailsPackN
              packName={selectedPack.name}
              packType={selectedPack.type}
              onClose={() => setSelectedPack(null)}
            />
          </div>
        )}
      </div>
    </>,
    document.body
  );
};

export default PopupUnlimitedBonus;
